import { render } from "./StepsSection.vue?vue&type=template&id=da4c439a&scoped=true"
import script from "./StepsSection.vue?vue&type=script&lang=js"
export * from "./StepsSection.vue?vue&type=script&lang=js"

import "./StepsSection.vue?vue&type=style&index=0&id=da4c439a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da4c439a"]])

export default __exports__